import { BackgroundColor } from '@digital-platform/rs-cms/domain';

export const bgCarouselColor: BackgroundColor = {
  tid: 0,
  name: 'background-color',
  cssColorName: 'bg-light-neutral',
};

export const richTextCardStart = '<medium style="font-weight: 600">';

export const richTextCardMiddle = '</medium><p style="font-size: 14px"><br>';

export const richTextCardEnd = '</p>';

export const richTextHeaderTitle =
  '<h3 style="color: #004a7c">Services Available</h3><p style="color: black"><small>All of our locations offer a variety of services, which vary by location. Please see the services below for how Republic Services can help support your needs.</small></p>';
